(() => {
  'use strict';

  const STORAGE_KEY = 'tayaRitualAnswersV1';
  const QUESTION_KEYS = [
    'q1',
    'q2',
    'q3',
    'q4',
    'q5',
    'q6',
    'q7',
    'q8'
  ];


  /* =========================================================
     PRODUCT SLOT DEFINITIONS
     ========================================================= */

  const ESSENTIAL_SHAMPOO_SLOTS = [
    'AWC_SHAM',
    'COP_SHAM',
    'BUR_SHAM',
    'KIN_SHAM'
  ];

  const ESSENTIAL_CONDITIONER_SLOTS = [
    'AWC_COND',
    'COP_COND',
    'BUR_COND',
    'KIN_COND',
    'IC_COND'
  ];


  const ESSENTIAL_FAMILY_BY_SLOT = {

    AWC_SHAM: 'AWC',
    AWC_COND: 'AWC',

    COP_SHAM: 'COP',
    COP_COND: 'COP',

    BUR_SHAM: 'BUR',
    BUR_COND: 'BUR',

    KIN_SHAM: 'KIN',
    KIN_COND: 'KIN',

    IC_COND: 'IC'

  };


  /*
    KIN_M IS NO LONGER SPECIALTY CARE.
  */

  const SPECIALTY_SLOTS = [
    'AWC_PL',
    'AWC_SC',
    'BUR_M',
    'BUR_OP',
    'GUA_S',
    'BBC_M'
  ];


  /*
    KIN_M NOW LIVES IN STYLING.
  */

  const STYLING_SLOTS = [

    'AWC_CR',
    'AWC_PF',
    'AWC_HS',
    'AWC_AT',
    'AWC_SH',
    'AWC_TM',

    'COP_BO',
    'COP_AV',
    'COP_MUD',

    'BUR_HS',
    'BUR_SS',

    'KIN_M',
    'KIN_IS',
    'KIN_FS'

  ];


  const STYLING_PRIMARY_SLOTS = [

    'AWC_CR',
    'AWC_PF',
    'AWC_AT',
    'AWC_TM',

    'COP_BO',
    'COP_MUD',

    'BUR_SS',

    'KIN_M',
    'KIN_IS',
    'KIN_FS'

  ];


  /* =========================================================
     ESSENTIAL CARE SCORING
     ========================================================= */

  const ESSENTIAL_SCORES = {

    q1: {

      straight: {
        AWC: 1,
        COP: 1
      },

      wavy: {
        AWC: 1,
        COP: 1,
        BUR: 1
      },

      curly: {
        BUR: 1,
        KIN: 1,
        IC: 1
      },

      coily: {
        BUR: 2,
        KIN: 1,
        IC: 1
      }

    },


    q2: {

      fine: {
        AWC: 3,
        COP: 2
      },

      medium: {
        AWC: 1,
        COP: 1,
        BUR: 1,
        KIN: 1
      },

      coarse: {
        BUR: 3,
        KIN: 1,
        IC: 1
      }

    },


    q3: {

      dry: {
        BUR: 3,
        KIN: 1
      },

      damaged: {
        BUR: 2,
        KIN: 3,
        IC: 1
      },

      thinning: {
        AWC: 3,
        COP: 1
      },

      breakage: {
        BUR: 1,
        KIN: 2,
        IC: 3
      },

      frizzy: {
        BUR: 3,
        KIN: 1
      }

    },


    q5: {

      processed_yes: {
        BUR: 2,
        KIN: 3,
        IC: 2
      },

      processed_no: {}

    },


    q6: {

      thickness_fullness: {
        AWC: 3,
        COP: 1
      },

      volume_lift_texture: {
        AWC: 2,
        COP: 3
      },

      moisture_frizz: {
        BUR: 3,
        KIN: 1
      },

      repair_restore: {
        BUR: 2,
        KIN: 3,
        IC: 1
      },

      strength_breakage: {
        BUR: 1,
        KIN: 3,
        IC: 3
      }

    }

  };


  const SHAMPOO_TIEBREAKERS = {

    thickness_fullness: [
      'AWC_SHAM',
      'COP_SHAM',
      'KIN_SHAM',
      'BUR_SHAM'
    ],

    volume_lift_texture: [
      'COP_SHAM',
      'AWC_SHAM',
      'KIN_SHAM',
      'BUR_SHAM'
    ],

    moisture_frizz: [
      'BUR_SHAM',
      'KIN_SHAM',
      'AWC_SHAM',
      'COP_SHAM'
    ],

    repair_restore: [
      'KIN_SHAM',
      'BUR_SHAM',
      'AWC_SHAM',
      'COP_SHAM'
    ],

    strength_breakage: [
      'KIN_SHAM',
      'BUR_SHAM',
      'AWC_SHAM',
      'COP_SHAM'
    ]

  };


  const CONDITIONER_TIEBREAKERS = {

    thickness_fullness: [
      'AWC_COND',
      'COP_COND',
      'KIN_COND',
      'BUR_COND',
      'IC_COND'
    ],

    volume_lift_texture: [
      'COP_COND',
      'AWC_COND',
      'KIN_COND',
      'BUR_COND',
      'IC_COND'
    ],

    moisture_frizz: [
      'BUR_COND',
      'KIN_COND',
      'IC_COND',
      'AWC_COND',
      'COP_COND'
    ],

    repair_restore: [
      'KIN_COND',
      'BUR_COND',
      'IC_COND',
      'AWC_COND',
      'COP_COND'
    ],

    strength_breakage: [
      'IC_COND',
      'KIN_COND',
      'BUR_COND',
      'AWC_COND',
      'COP_COND'
    ]

  };


  /* =========================================================
     TARGETED CARE
     ========================================================= */

  const SPECIALTY_META = {

    AWC_PL: {
      role: 'overnight_fullness',
      shortBenefit: 'fullness and body'
    },

    AWC_SC: {
      role: 'scalp_reset',
      shortBenefit: 'a cleaner scalp foundation'
    },

    BUR_M: {
      role: 'immediate_repair',
      shortBenefit: 'moisture, softness and restorative repair'
    },

    BUR_OP: {
      role: 'overnight_repair',
      shortBenefit: 'deeper restorative care'
    },

    GUA_S: {
      role: 'scalp_density',
      shortBenefit: 'scalp and density care'
    },

    BBC_M: {
      role: 'strength_breakage',
      shortBenefit: 'strength and breakage support'
    }

  };


  const SPECIALTY_SCORES = {

    q1: {

      straight: {
        AWC_PL: 1,
        AWC_SC: 1
      },

      wavy: {
        AWC_PL: 1,
        BUR_M: 1
      },

      curly: {
        BUR_M: 2,
        BUR_OP: 1,
        BBC_M: 1
      },

      coily: {
        BUR_M: 2,
        BUR_OP: 2,
        BBC_M: 1
      }

    },


    q2: {

      fine: {
        AWC_PL: 3,
        AWC_SC: 1
      },

      medium: {
        BUR_M: 1,
        BUR_OP: 1
      },

      coarse: {
        BUR_M: 3,
        BUR_OP: 2,
        BBC_M: 1
      }

    },


    q3: {

      dry: {
        BUR_M: 3,
        BUR_OP: 3
      },

      damaged: {
        BUR_M: 3,
        BUR_OP: 3,
        BBC_M: 1
      },

      thinning: {
        AWC_PL: 1,
        GUA_S: 3
      },

      breakage: {
        BUR_M: 1,
        BUR_OP: 2,
        BBC_M: 3
      },

      frizzy: {
        BUR_M: 2,
        BUR_OP: 1
      }

    },


    q4: {

      blow_dry: {
        BUR_M: 1,
        BUR_OP: 1
      },

      heat_tools: {
        BUR_M: 2,
        BUR_OP: 2,
        BBC_M: 1
      },

      natural_texture: {
        BUR_M: 1
      },

      hands_style: {}

    },


    q5: {

      processed_yes: {
        BUR_M: 3,
        BUR_OP: 2,
        BBC_M: 1
      },

      processed_no: {}

    },


    q6: {

      thickness_fullness: {
        AWC_PL: 3,
        AWC_SC: 1
      },

      volume_lift_texture: {
        AWC_PL: 2,
        AWC_SC: 2
      },

      moisture_frizz: {
        BUR_M: 3,
        BUR_OP: 2
      },

      repair_restore: {
        BUR_M: 4,
        BUR_OP: 3,
        BBC_M: 1
      },

      strength_breakage: {
        BUR_M: 1,
        BUR_OP: 2,
        BBC_M: 3
      }

    }

  };


  const SPECIALTY_TIEBREAKERS = {

    thickness_fullness: [
      'AWC_PL',
      'AWC_SC',
      'BUR_M',
      'BUR_OP',
      'BBC_M',
      'GUA_S'
    ],

    volume_lift_texture: [
      'AWC_PL',
      'AWC_SC',
      'BUR_M',
      'BUR_OP',
      'BBC_M',
      'GUA_S'
    ],

    moisture_frizz: [
      'BUR_M',
      'BUR_OP',
      'BBC_M',
      'AWC_PL',
      'AWC_SC',
      'GUA_S'
    ],

    repair_restore: [
      'BUR_M',
      'BUR_OP',
      'BBC_M',
      'AWC_PL',
      'AWC_SC',
      'GUA_S'
    ],

    strength_breakage: [
      'BBC_M',
      'BUR_M',
      'BUR_OP',
      'AWC_PL',
      'AWC_SC',
      'GUA_S'
    ]

  };


  /* =========================================================
     STYLE & FINISH
     ========================================================= */

  const STYLING_META = {

    AWC_CR: {
      role: 'thickening_styler',
      stage: 'style'
    },

    AWC_PF: {
      role: 'precision_plumper',
      stage: 'style'
    },

    AWC_HS: {
      role: 'strong_hairspray',
      stage: 'finish',
      isHairspray: true
    },

    AWC_AT: {
      role: 'root_lift_texture',
      stage: 'style'
    },

    AWC_SH: {
      role: 'setting_hairspray',
      stage: 'finish',
      isHairspray: true
    },

    AWC_TM: {
      role: 'thickening_prestyler',
      stage: 'style',
      provisional: true
    },

    COP_BO: {
      role: 'volume_prestyler',
      stage: 'style'
    },

    COP_AV: {
      role: 'dry_volume_hairspray',
      stage: 'finish',
      isHairspray: true
    },

    COP_MUD: {
      role: 'texture_mud',
      stage: 'style'
    },

    BUR_HS: {
      role: 'medium_shine_hairspray',
      stage: 'finish',
      isHairspray: true
    },

    /*
      BURITI SILK SERUM / OIL

      Stronger repair and nourishment.
      Priority for Curly/Coily hair.
      Can act as complete Style & Finish
      when no hold is wanted.
    */

    BUR_SS: {
      role: 'repair_smooth_finisher',
      stage: 'finish',
      standaloneCapable: true
    },

    /*
      KINWA INSTA-SEAL

      Lighter cuticle sealing / frizz control /
      color protection / heat styling prep.

      Particularly relevant for:
      - blow drying
      - flat ironing
      - other heat tools
      - processed/color-treated hair
    */

    KIN_M: {
      role: 'cuticle_seal_heat_prep',
      stage: 'style',
      standaloneCapable: true
    },

    KIN_IS: {
      role: 'hybrid_styler',
      stage: 'style',
      hybrid: true,
      standaloneCapable: true
    },

    KIN_FS: {
      role: 'hybrid_finger_styler',
      stage: 'style',
      hybrid: true,
      standaloneCapable: true
    }

  };


  const STYLING_SCORES = {

    q1: {

      straight: {
        AWC_CR: 1,
        AWC_PF: 1,
        AWC_HS: 1,
        COP_BO: 1,
        COP_AV: 1,
        KIN_M: 2
      },

      wavy: {
        AWC_CR: 1,
        AWC_PF: 1,
        COP_BO: 1,
        COP_AV: 1,
        BUR_HS: 1,
        BUR_SS: 1,
        KIN_M: 2,
        KIN_IS: 1,
        KIN_FS: 2
      },

      curly: {
        AWC_PF: 1,
        BUR_HS: 2,
        BUR_SS: 4,
        KIN_M: 1,
        KIN_IS: 2,
        KIN_FS: 3
      },

      coily: {
        BUR_HS: 2,
        BUR_SS: 5,
        KIN_M: 1,
        KIN_IS: 2,
        KIN_FS: 3
      }

    },


    q2: {

      fine: {
        AWC_CR: 3,
        AWC_PF: 2,
        AWC_HS: 2,
        AWC_AT: 3,
        COP_BO: 3,
        COP_AV: 3,
        KIN_M: 1,
        KIN_IS: 1,
        KIN_FS: 1
      },

      medium: {
        AWC_CR: 1,
        AWC_PF: 1,
        COP_BO: 1,
        COP_AV: 1,
        BUR_HS: 1,
        BUR_SS: 1,
        KIN_M: 2,
        KIN_IS: 1,
        KIN_FS: 1
      },

      coarse: {
        AWC_PF: 1,
        COP_MUD: 2,
        BUR_HS: 2,
        BUR_SS: 4,
        KIN_M: 2,
        KIN_IS: 2,
        KIN_FS: 2
      }

    },


    q3: {

      dry: {
        BUR_HS: 3,
        BUR_SS: 5,
        KIN_M: 2,
        KIN_IS: 1,
        KIN_FS: 1
      },

      damaged: {
        BUR_HS: 2,
        BUR_SS: 5,
        KIN_M: 4,
        KIN_IS: 2,
        KIN_FS: 1
      },

      thinning: {
        AWC_CR: 3,
        AWC_PF: 3,
        AWC_HS: 2,
        AWC_AT: 3,
        COP_BO: 2,
        COP_AV: 3,
        KIN_IS: 1
      },

      breakage: {
        BUR_HS: 2,
        BUR_SS: 3,
        KIN_M: 2,
        KIN_IS: 3,
        KIN_FS: 3
      },

      frizzy: {
        AWC_PF: 1,
        BUR_HS: 2,
        BUR_SS: 4,
        KIN_M: 5,
        KIN_IS: 2,
        KIN_FS: 2
      }

    },


    q4: {

      blow_dry: {
        AWC_CR: 3,
        AWC_PF: 1,
        AWC_HS: 1,
        COP_BO: 3,
        COP_AV: 1,
        BUR_HS: 1,
        BUR_SS: 1,
        KIN_M: 4,
        KIN_IS: 1
      },

      heat_tools: {
        AWC_CR: 1,
        AWC_PF: 2,
        AWC_HS: 2,
        AWC_SH: 3,
        COP_BO: 2,
        COP_AV: 2,
        BUR_HS: 1,
        BUR_SS: 2,
        KIN_M: 5,
        KIN_IS: 1,
        KIN_FS: 1
      },

      natural_texture: {
        AWC_CR: 2,
        AWC_PF: 1,
        COP_MUD: 2,
        BUR_HS: 1,
        BUR_SS: 3,
        KIN_M: 1,
        KIN_IS: 2,
        KIN_FS: 3
      },

      hands_style: {
        AWC_CR: 1,
        AWC_PF: 3,
        AWC_AT: 2,
        COP_AV: 1,
        COP_MUD: 3,
        BUR_SS: 2,
        KIN_M: 1,
        KIN_IS: 3,
        KIN_FS: 3
      }

    },


    q5: {

      processed_yes: {
        AWC_CR: 1,
        AWC_PF: 1,
        BUR_HS: 2,
        BUR_SS: 4,
        KIN_M: 5,
        KIN_IS: 1,
        KIN_FS: 1
      },

      processed_no: {}

    },


    q6: {

      thickness_fullness: {
        AWC_CR: 3,
        AWC_PF: 3,
        AWC_HS: 3,
        AWC_AT: 3,
        COP_BO: 2,
        COP_AV: 2,
        KIN_IS: 1,
        KIN_FS: 1
      },

      volume_lift_texture: {
        AWC_CR: 2,
        AWC_PF: 2,
        AWC_HS: 2,
        AWC_AT: 3,
        AWC_SH: 2,
        COP_BO: 3,
        COP_AV: 3,
        COP_MUD: 3,
        BUR_HS: 1,
        KIN_M: 1,
        KIN_IS: 2,
        KIN_FS: 2
      },

      moisture_frizz: {
        BUR_HS: 2,
        BUR_SS: 5,
        KIN_M: 5,
        KIN_IS: 2,
        KIN_FS: 2
      },

      repair_restore: {
        BUR_HS: 1,
        BUR_SS: 6,
        KIN_M: 5,
        KIN_IS: 2,
        KIN_FS: 1
      },

      strength_breakage: {
        BUR_HS: 2,
        BUR_SS: 2,
        KIN_M: 2,
        KIN_IS: 4,
        KIN_FS: 4
      }

    },


    q7: {

      very_short: {
        AWC_CR: 2,
        AWC_PF: 3,
        AWC_HS: 1,
        AWC_AT: 3,
        AWC_SH: 2,
        COP_AV: 2,
        COP_MUD: 3,
        BUR_HS: 1,
        KIN_M: 1,
        KIN_IS: 3,
        KIN_FS: 3
      },

      short: {
        AWC_CR: 2,
        AWC_PF: 3,
        AWC_HS: 2,
        AWC_AT: 3,
        AWC_SH: 2,
        COP_BO: 1,
        COP_AV: 3,
        COP_MUD: 3,
        BUR_HS: 1,
        BUR_SS: 1,
        KIN_M: 1,
        KIN_IS: 2,
        KIN_FS: 3
      },

      medium_length: {
        AWC_CR: 2,
        AWC_PF: 2,
        AWC_HS: 2,
        AWC_AT: 2,
        AWC_SH: 2,
        COP_BO: 3,
        COP_AV: 3,
        COP_MUD: 1,
        BUR_HS: 2,
        BUR_SS: 2,
        KIN_M: 2,
        KIN_IS: 2,
        KIN_FS: 2
      },

      long: {
        AWC_CR: 1,
        AWC_PF: 1,
        AWC_HS: 2,
        AWC_AT: 1,
        AWC_SH: 2,
        COP_BO: 3,
        COP_AV: 2,
        BUR_HS: 3,
        BUR_SS: 4,
        KIN_M: 2,
        KIN_IS: 1,
        KIN_FS: 1
      }

    },


    q8: {

      no_hold: {
        AWC_CR: 1,
        BUR_SS: 5,
        KIN_M: 5,
        KIN_IS: 3,
        KIN_FS: 3
      },

      hold_light: {
        AWC_PF: 1,
        BUR_SS: 3,
        KIN_M: 3,
        KIN_IS: 3,
        KIN_FS: 3
      },

      hold_medium: {
        AWC_HS: 1,
        COP_AV: 2,
        BUR_HS: 3,
        KIN_M: 1,
        KIN_IS: 2,
        KIN_FS: 2
      },

      hold_strong: {
        AWC_HS: 3,
        AWC_SH: 3,
        COP_AV: 2,
        AWC_PF: 2
      }

    }

  };


  const STYLING_PRIMARY_TIEBREAKERS = {

    thickness_fullness: [
      'AWC_CR',
      'AWC_PF',
      'AWC_AT',
      'COP_BO',
      'KIN_IS',
      'KIN_FS',
      'COP_MUD',
      'BUR_SS',
      'KIN_M',
      'AWC_TM'
    ],

    volume_lift_texture: [
      'COP_BO',
      'COP_MUD',
      'AWC_AT',
      'AWC_PF',
      'KIN_FS',
      'KIN_IS',
      'AWC_CR',
      'BUR_SS',
      'KIN_M',
      'AWC_TM'
    ],

    moisture_frizz: [
      'KIN_M',
      'BUR_SS',
      'KIN_IS',
      'KIN_FS',
      'AWC_PF',
      'AWC_CR',
      'COP_BO',
      'COP_MUD',
      'AWC_AT',
      'AWC_TM'
    ],

    repair_restore: [
      'BUR_SS',
      'KIN_M',
      'KIN_IS',
      'KIN_FS',
      'AWC_PF',
      'AWC_CR',
      'COP_BO',
      'COP_MUD',
      'AWC_AT',
      'AWC_TM'
    ],

    strength_breakage: [
      'KIN_IS',
      'KIN_FS',
      'BUR_SS',
      'KIN_M',
      'AWC_PF',
      'AWC_CR',
      'COP_MUD',
      'COP_BO',
      'AWC_AT',
      'AWC_TM'
    ]

  };


  /* =========================================================
     COPY LABELS
     ========================================================= */

  const TEXTURE_LABELS = {

    fine: 'fine',

    medium:
      'medium-textured',

    coarse:
      'coarse'

  };


  const CONDITION_LABELS = {

    dry:
      'dry',

    damaged:
      'damaged',

    thinning:
      'thinning',

    breakage:
      'breakage-prone',

    frizzy:
      'frizz-prone'

  };


  const GOAL_LABELS = {

    thickness_fullness:
      'thickness and fullness',

    volume_lift_texture:
      'volume, lift and texture',

    moisture_frizz:
      'moisture, shine and frizz control',

    repair_restore:
      'repair and restoration',

    strength_breakage:
      'strength and less breakage'

  };


  const STYLE_METHOD_LABELS = {

    blow_dry:
      'blow-dry styling',

    heat_tools:
      'heat-tool styling',

    natural_texture:
      'natural-texture styling',

    hands_style:
      'hands-on shaping and texturizing'

  };


  const STYLE_GOAL_LABELS = {

    thickness_fullness:
      'thickness and fullness',

    volume_lift_texture:
      'volume, lift and texture',

    moisture_frizz:
      'smoothness, shine and frizz control',

    repair_restore:
      'repair-conscious styling',

    strength_breakage:
      'flexible styling and control'

  };


  const HOLD_LABELS = {

    no_hold:
      'natural movement without added hold',

    hold_light:
      'light, flexible hold',

    hold_medium:
      'medium, natural hold',

    hold_strong:
      'strong, lasting hold'

  };


  /* =========================================================
     BASIC UTILITIES
     ========================================================= */

  function safeParseJSON(
    text,
    fallback = null
  ) {

    try {

      return JSON.parse(text);

    } catch (error) {

      return fallback;

    }

  }


  function loadStoredAnswers() {

    const stored =
      safeParseJSON(
        sessionStorage.getItem(
          STORAGE_KEY
        ),
        {}
      );


    if (
      !stored ||
      typeof stored !== 'object'
    ) {

      return {};

    }


    return QUESTION_KEYS.reduce(
      (answers, key) => {

        if (
          typeof stored[key] ===
            'string' &&
          stored[key]
        ) {

          answers[key] =
            stored[key];

        }


        return answers;

      },
      {}
    );

  }


  function saveAnswers(
    answers
  ) {

    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(
        answers
      )
    );

  }


  function parseProductRegistry(
    root
  ) {

    const node =
      root.querySelector(
        '[data-taya-product-registry]'
      );


    if (!node) {

      return {
        sectionId: null,
        products: []
      };

    }


    return safeParseJSON(
      node.textContent,
      {
        sectionId: null,
        products: []
      }
    );

  }


  function productMapBySlot(
    products
  ) {

    return (
      products || []
    ).reduce(
      (map, product) => {

        if (
          product &&
          product.slot
        ) {

          map[
            product.slot
          ] = product;

        }


        return map;

      },
      {}
    );

  }


  function tieRank(
    slot,
    order
  ) {

    const index =
      order.indexOf(
        slot
      );


    return index === -1
      ? Number.MAX_SAFE_INTEGER
      : index;

  }


  function eligible(
    item
  ) {

    return Boolean(

      item &&

      item.configured &&

      item.available &&

      !item.meta?.provisional

    );

  }


  function clearElement(
    element
  ) {

    while (
      element &&
      element.firstChild
    ) {

      element.removeChild(
        element.firstChild
      );

    }

  }


  /* =========================================================
     ESSENTIAL ENGINE
     ========================================================= */

  function applyEssentialAnswerScores(
    scoreMap,
    questionKey,
    answerValue
  ) {

    const familyScores =
      ESSENTIAL_SCORES[
        questionKey
      ]?.[
        answerValue
      ] || {};


    Object.entries(
      familyScores
    ).forEach(
      ([family, points]) => {

        scoreMap[
          family
        ] =
          (
            scoreMap[
              family
            ] || 0
          ) +
          points;

      }
    );

  }


  function scoreEssentialFamilies(
    answers
  ) {

    const scores = {

      AWC: 0,

      COP: 0,

      BUR: 0,

      KIN: 0,

      IC: 0

    };


    [
      'q1',
      'q2',
      'q3',
      'q5',
      'q6'
    ].forEach(
      (questionKey) => {

        applyEssentialAnswerScores(

          scores,

          questionKey,

          answers[
            questionKey
          ]

        );

      }
    );


    if (

      answers.q3 ===
        'damaged' &&

      answers.q5 ===
        'processed_yes' &&

      answers.q6 ===
        'repair_restore'

    ) {

      scores.KIN += 2;

    }


    return scores;

  }


  function rankEssentialSlots(

    slots,

    familyScores,

    productsBySlot,

    tieOrder

  ) {

    return slots

      .map(
        (slot) => {

          const family =
            ESSENTIAL_FAMILY_BY_SLOT[
              slot
            ];


          const product =
            productsBySlot[
              slot
            ] || null;


          return {

            slot,

            family,

            score:
              familyScores[
                family
              ] || 0,

            product,

            configured:
              Boolean(
                product
              ),

            available:
              Boolean(
                product &&
                product.available
              )

          };

        }
      )

      .sort(
        (a, b) => {

          if (
            b.score !==
            a.score
          ) {

            return (
              b.score -
              a.score
            );

          }


          return (

            tieRank(
              a.slot,
              tieOrder
            ) -

            tieRank(
              b.slot,
              tieOrder
            )

          );

        }
      );

  }


  function firstEligible(
    ranking
  ) {

    return (

      ranking.find(
        (item) =>

          item.configured &&

          item.available
      ) ||

      null

    );

  }


  function calculateEssentialCare(
    answers,
    products
  ) {

    const shampooFamilyScores =
      scoreEssentialFamilies(
        answers
      );


    const conditionerFamilyScores = {
      ...shampooFamilyScores
    };


    if (
      answers.q6 ===
      'strength_breakage'
    ) {

      conditionerFamilyScores.KIN =
        Math.max(

          0,

          conditionerFamilyScores.KIN -
            1

        );

    }


    const productsBySlot =
      productMapBySlot(
        products
      );


    const shampooTieOrder =

      SHAMPOO_TIEBREAKERS[
        answers.q6
      ] ||

      ESSENTIAL_SHAMPOO_SLOTS;


    const conditionerTieOrder =

      CONDITIONER_TIEBREAKERS[
        answers.q6
      ] ||

      ESSENTIAL_CONDITIONER_SLOTS;


    const shampooRanking =
      rankEssentialSlots(

        ESSENTIAL_SHAMPOO_SLOTS,

        shampooFamilyScores,

        productsBySlot,

        shampooTieOrder

      );


    let conditionerRanking =
      rankEssentialSlots(

        ESSENTIAL_CONDITIONER_SLOTS,

        conditionerFamilyScores,

        productsBySlot,

        conditionerTieOrder

      );


    if (

      answers.q3 ===
        'breakage' &&

      answers.q6 ===
        'strength_breakage'

    ) {

      conditionerRanking =
        conditionerRanking.sort(
          (a, b) => {

            if (

              a.slot ===
                'IC_COND' &&

              b.slot !==
                'IC_COND'

            ) {

              return -1;

            }


            if (

              b.slot ===
                'IC_COND' &&

              a.slot !==
                'IC_COND'

            ) {

              return 1;

            }


            if (
              b.score !==
              a.score
            ) {

              return (
                b.score -
                a.score
              );

            }


            return (

              tieRank(
                a.slot,
                conditionerTieOrder
              ) -

              tieRank(
                b.slot,
                conditionerTieOrder
              )

            );

          }
        );

    }


    return {

      shampoo:
        firstEligible(
          shampooRanking
        ),

      conditioner:
        firstEligible(
          conditionerRanking
        ),

      shampooRanking,

      conditionerRanking

    };

  }


  function buildEssentialReason(
    answers
  ) {

    const texture =
      TEXTURE_LABELS[
        answers.q2
      ];


    const condition =
      CONDITION_LABELS[
        answers.q3
      ];


    const goal =
      GOAL_LABELS[
        answers.q6
      ];


    const descriptors = [

      texture,

      condition

    ]
      .filter(Boolean)
      .join(', ');


    return (
      `Chosen for ${descriptors} hair ` +
      `to support ${goal}.`
    );

  }


  /* =========================================================
     TARGETED CARE ENGINE
     ========================================================= */

  function scoreSpecialty(
    answers
  ) {

    const scoreMap = {};

    const contributionMap =
      {};


    SPECIALTY_SLOTS.forEach(
      (slot) => {

        scoreMap[
          slot
        ] = 0;

        contributionMap[
          slot
        ] = 0;

      }
    );


    [
      'q1',
      'q2',
      'q3',
      'q4',
      'q5',
      'q6'
    ].forEach(
      (questionKey) => {

        const pointsForAnswer =

          SPECIALTY_SCORES[
            questionKey
          ]?.[
            answers[
              questionKey
            ]
          ] ||

          {};


        Object.entries(
          pointsForAnswer
        ).forEach(
          ([slot, points]) => {

            if (

              !SPECIALTY_SLOTS.includes(
                slot
              ) ||

              !Number.isFinite(
                points
              ) ||

              points <= 0

            ) {

              return;

            }


            scoreMap[
              slot
            ] += points;


            contributionMap[
              slot
            ] += 1;

          }
        );

      }
    );


    return {

      scoreMap,

      contributionMap

    };

  }


  function rankSpecialty(
    answers,
    products
  ) {

    const {

      scoreMap,

      contributionMap

    } =
      scoreSpecialty(
        answers
      );


    const productsBySlot =
      productMapBySlot(
        products
      );


    const tieOrder =

      SPECIALTY_TIEBREAKERS[
        answers.q6
      ] ||

      SPECIALTY_SLOTS;


    return SPECIALTY_SLOTS

      .map(
        (slot) => ({

          slot,

          score:
            scoreMap[
              slot
            ] || 0,

          contributions:
            contributionMap[
              slot
            ] || 0,

          meta:
            SPECIALTY_META[
              slot
            ],

          product:
            productsBySlot[
              slot
            ] || null,

          configured:
            Boolean(
              productsBySlot[
                slot
              ]
            ),

          available:
            Boolean(

              productsBySlot[
                slot
              ] &&

              productsBySlot[
                slot
              ].available

            )

        })
      )

      .sort(
        (a, b) => {

          if (
            b.score !==
            a.score
          ) {

            return (
              b.score -
              a.score
            );

          }


          return (

            tieRank(
              a.slot,
              tieOrder
            ) -

            tieRank(
              b.slot,
              tieOrder
            )

          );

        }
      );

  }


  function getSpecialtyPrimaryOverrideSlot(
    answers
  ) {

    if (
      answers.q3 ===
      'thinning'
    ) {

      return 'GUA_S';

    }


    if (

      answers.q2 ===
        'fine' &&

      answers.q6 ===
        'thickness_fullness' &&

      answers.q3 !==
        'thinning'

    ) {

      return 'AWC_PL';

    }


    if (

      answers.q3 ===
        'breakage' &&

      answers.q6 ===
        'strength_breakage'

    ) {

      return 'BBC_M';

    }


    /*
      DAMAGED + PROCESSED + REPAIR
      MUST RETURN A TRUE REPAIR MASK.
    */

    if (

      answers.q3 ===
        'damaged' &&

      answers.q5 ===
        'processed_yes' &&

      answers.q6 ===
        'repair_restore'

    ) {

      return 'BUR_M';

    }


    if (

      answers.q3 ===
        'dry' &&

      answers.q6 ===
        'moisture_frizz' &&

      answers.q5 !==
        'processed_yes'

    ) {

      return 'BUR_M';

    }


    return null;

  }


  function chooseSpecialtyPrimary(
    ranking,
    answers
  ) {

    const overrideSlot =
      getSpecialtyPrimaryOverrideSlot(
        answers
      );


    if (
      overrideSlot
    ) {

      const overrideItem =
        ranking.find(
          (item) =>

            item.slot ===
            overrideSlot
        );


      if (
        eligible(
          overrideItem
        )
      ) {

        return overrideItem;

      }

    }


    return (

      ranking.find(
        eligible
      ) ||

      null

    );

  }


  function isStrongRepairProfile(
    answers
  ) {

    return (

      answers.q3 ===
        'damaged' &&

      answers.q5 ===
        'processed_yes' &&

      answers.q6 ===
        'repair_restore'

    );

  }


  function specialtyPairingAllowed(

    primary,

    candidate,

    answers

  ) {

    if (

      !primary ||

      !candidate ||

      primary.slot ===
        candidate.slot

    ) {

      return false;

    }


    if (

      primary.meta?.role &&

      candidate.meta?.role &&

      primary.meta.role ===
        candidate.meta.role

    ) {

      return false;

    }


    const pair =
      new Set([

        primary.slot,

        candidate.slot

      ]);


    if (

      pair.has(
        'AWC_PL'
      ) &&

      pair.has(
        'BUR_OP'
      )

    ) {

      return false;

    }


    if (

      pair.has(
        'BUR_M'
      ) &&

      pair.has(
        'BUR_OP'
      ) &&

      !isStrongRepairProfile(
        answers
      )

    ) {

      return false;

    }


    return true;

  }


  function chooseSpecialtyComplementary(

    ranking,

    primary,

    answers

  ) {

    if (
      !primary
    ) {

      return null;

    }


    return (

      ranking.find(
        (item) => {

          if (

            !eligible(
              item
            ) ||

            item.slot ===
              primary.slot

          ) {

            return false;

          }


          if (

            item.score <
              4 ||

            item.contributions <
              2

          ) {

            return false;

          }


          return (
            specialtyPairingAllowed(

              primary,

              item,

              answers

            )
          );

        }
      ) ||

      null

    );

  }


  function calculateSpecialtyCare(
    answers,
    products
  ) {

    const ranking =
      rankSpecialty(
        answers,
        products
      );


    const primary =
      chooseSpecialtyPrimary(
        ranking,
        answers
      );


    const complementary =
      chooseSpecialtyComplementary(

        ranking,

        primary,

        answers

      );


    return {

      ranking,

      primary,

      complementary

    };

  }


  function buildSpecialtyReason(

    item,

    isComplementary

  ) {

    if (
      !item
    ) {

      return '';

    }


    const benefit =

      item.meta
        ?.shortBenefit ||

      'your targeted hair-care needs';


    return isComplementary

      ? `Optional support for ${benefit}.`

      : `Prioritized to support ${benefit} based on your quiz responses.`;

  }


  /* =========================================================
     STYLE & FINISH ENGINE
     ========================================================= */

  function scoreStyling(
    answers
  ) {

    const scoreMap = {};


    STYLING_SLOTS.forEach(
      (slot) => {

        scoreMap[
          slot
        ] = 0;

      }
    );


    [
      'q1',
      'q2',
      'q3',
      'q4',
      'q5',
      'q6',
      'q7',
      'q8'
    ].forEach(
      (questionKey) => {

        const pointsForAnswer =

          STYLING_SCORES[
            questionKey
          ]?.[
            answers[
              questionKey
            ]
          ] ||

          {};


        Object.entries(
          pointsForAnswer
        ).forEach(
          ([slot, points]) => {

            if (

              STYLING_SLOTS.includes(
                slot
              ) &&

              Number.isFinite(
                points
              ) &&

              points > 0

            ) {

              scoreMap[
                slot
              ] += points;

            }

          }
        );

      }
    );


    return scoreMap;

  }


  function buildStylingRanking(
    answers,
    products
  ) {

    const scoreMap =
      scoreStyling(
        answers
      );


    const productsBySlot =
      productMapBySlot(
        products
      );


    const tieOrder =

      STYLING_PRIMARY_TIEBREAKERS[
        answers.q6
      ] ||

      STYLING_PRIMARY_SLOTS;


    return STYLING_SLOTS

      .map(
        (slot) => ({

          slot,

          score:
            scoreMap[
              slot
            ] || 0,

          meta:
            STYLING_META[
              slot
            ],

          product:
            productsBySlot[
              slot
            ] || null,

          configured:
            Boolean(
              productsBySlot[
                slot
              ]
            ),

          available:
            Boolean(

              productsBySlot[
                slot
              ] &&

              productsBySlot[
                slot
              ].available

            )

        })
      )

      .sort(
        (a, b) => {

          if (
            b.score !==
            a.score
          ) {

            return (
              b.score -
              a.score
            );

          }


          return (

            tieRank(
              a.slot,
              tieOrder
            ) -

            tieRank(
              b.slot,
              tieOrder
            )

          );

        }
      );

  }


  function findEligibleSlot(
    ranking,
    slot
  ) {

    const item =
      ranking.find(
        (candidate) =>

          candidate.slot ===
          slot
      );


    return eligible(
      item
    )
      ? item
      : null;

  }


  /*
    REPAIR-FOCUSED PROFILES SHOULD NOT
    FALL THROUGH TO RANDOM VOLUME /
    THICKENING STYLERS.
  */

  function isRepairFocusedProfile(
    answers
  ) {

    return (

      answers.q6 ===
        'repair_restore' ||

      (

        answers.q3 ===
          'damaged' &&

        answers.q5 ===
          'processed_yes'

      )

    );

  }


  function isStylingPrimaryAllowed(
    item,
    answers
  ) {

    if (
      !eligible(
        item
      )
    ) {

      return false;

    }


    /*
      REPAIR POOL
    */

    if (

      isRepairFocusedProfile(
        answers
      ) &&

      ![
        'BUR_SS',
        'KIN_M',
        'KIN_IS',
        'KIN_FS'
      ].includes(
        item.slot
      )

    ) {

      return false;

    }


    /*
      NO HOLD MEANS NO HAIRSPRAY.
    */

    if (

      answers.q8 ===
        'no_hold' &&

      item.meta
        ?.isHairspray

    ) {

      return false;

    }


    return (
      STYLING_PRIMARY_SLOTS.includes(
        item.slot
      )
    );

  }


  function getStylingPrimaryOverride(
    ranking,
    answers
  ) {

    const isCurlyOrCoily =
      [
        'curly',
        'coily'
      ].includes(
        answers.q1
      );


    const isStraightOrWavy =
      [
        'straight',
        'wavy'
      ].includes(
        answers.q1
      );


    const isHeatStyled =
      [
        'blow_dry',
        'heat_tools'
      ].includes(
        answers.q4
      );


    /*
      CURLY / COILY + REPAIR

      BURITI SERUM/OIL WINS.
    */

    if (

      isCurlyOrCoily &&

      answers.q6 ===
        'repair_restore' &&

      (

        answers.q3 ===
          'damaged' ||

        answers.q3 ===
          'dry' ||

        answers.q5 ===
          'processed_yes'

      )

    ) {

      const item =
        findEligibleSlot(

          ranking,

          'BUR_SS'

        );


      if (
        item
      ) {

        return item;

      }

    }


    /*
      STRAIGHT / WAVY + HEAT TOOLS +
      DAMAGE / PROCESSING / FRIZZ

      INSTA-SEAL WINS.
    */

    if (

      isStraightOrWavy &&

      isHeatStyled &&

      (

        answers.q5 ===
          'processed_yes' ||

        answers.q3 ===
          'damaged' ||

        answers.q3 ===
          'frizzy'

      )

    ) {

      const item =
        findEligibleSlot(

          ranking,

          'KIN_M'

        );


      if (
        item
      ) {

        return item;

      }

    }


    /*
      FRIZZ + PROCESSING + HEAT TOOLS
    */

    if (

      isHeatStyled &&

      answers.q3 ===
        'frizzy' &&

      answers.q5 ===
        'processed_yes'

    ) {

      const item =
        findEligibleSlot(

          ranking,

          'KIN_M'

        );


      if (
        item
      ) {

        return item;

      }

    }


    /*
      REPAIR + HEAT TOOLS:
      BURITI FOR CURLY/COILY,
      INSTA-SEAL OTHERWISE.
    */

    if (

      answers.q6 ===
        'repair_restore' &&

      isHeatStyled

    ) {

      const preferredSlot =

        isCurlyOrCoily

          ? 'BUR_SS'

          : 'KIN_M';


      const item =
        findEligibleSlot(

          ranking,

          preferredSlot

        );


      if (
        item
      ) {

        return item;

      }

    }


    /*
      NO HOLD + MOISTURE/FRIZZ:
      BURITI FOR CURLY/COILY,
      INSTA-SEAL OTHERWISE.
    */

    if (

      answers.q8 ===
        'no_hold' &&

      answers.q6 ===
        'moisture_frizz'

    ) {

      const preferredSlot =

        isCurlyOrCoily

          ? 'BUR_SS'

          : 'KIN_M';


      const item =
        findEligibleSlot(

          ranking,

          preferredSlot

        );


      if (
        item
      ) {

        return item;

      }

    }


    /*
      VOLUME / LIFT BLOW DRY.
    */

    if (

      answers.q4 ===
        'blow_dry' &&

      answers.q6 ===
        'volume_lift_texture'

    ) {

      const item =
        findEligibleSlot(

          ranking,

          'COP_BO'

        );


      if (
        item
      ) {

        return item;

      }

    }


    /*
      SHORT HAIR + HAND STYLING +
      TEXTURE/VOLUME.
    */

    if (

      answers.q4 ===
        'hands_style' &&

      [
        'very_short',
        'short'
      ].includes(
        answers.q7
      ) &&

      answers.q6 ===
        'volume_lift_texture'

    ) {

      const item =
        findEligibleSlot(

          ranking,

          'COP_MUD'

        );


      if (
        item
      ) {

        return item;

      }

    }


    /*
      STRENGTH + HAND STYLING.
    */

    if (

      answers.q4 ===
        'hands_style' &&

      answers.q6 ===
        'strength_breakage'

    ) {

      const item =
        findEligibleSlot(

          ranking,

          'KIN_FS'

        );


      if (
        item
      ) {

        return item;

      }

    }


    /*
      THICKNESS + HEAT TOOLS.
    */

    if (

      answers.q4 ===
        'heat_tools' &&

      answers.q6 ===
        'thickness_fullness'

    ) {

      const item =
        findEligibleSlot(

          ranking,

          'AWC_PF'

        );


      if (
        item
      ) {

        return item;

      }

    }


    /*
      FINE + THICKNESS + BLOW DRY.
    */

    if (

      answers.q2 ===
        'fine' &&

      answers.q6 ===
        'thickness_fullness' &&

      answers.q4 ===
        'blow_dry'

    ) {

      const item =
        findEligibleSlot(

          ranking,

          'AWC_CR'

        );


      if (
        item
      ) {

        return item;

      }

    }


    return null;

  }


  function chooseStylingPrimary(
    ranking,
    answers
  ) {

    const override =
      getStylingPrimaryOverride(

        ranking,

        answers

      );


    if (
      override
    ) {

      return override;

    }


    return (

      ranking.find(
        (item) =>

          isStylingPrimaryAllowed(

            item,

            answers

          )
      ) ||

      null

    );

  }


  function preferredFinishSlots(
    answers
  ) {

    /*
      NO HOLD = NO SECOND FINISHER.
    */

    if (
      answers.q8 ===
      'no_hold'
    ) {

      return [];

    }


    /*
      LIGHT HOLD:
      HYBRIDS SHOULD HANDLE IT.
      NO FORCED SECOND PRODUCT.
    */

    if (
      answers.q8 ===
      'hold_light'
    ) {

      return [];

    }


    if (
      answers.q8 ===
      'hold_medium'
    ) {

      if (

        answers.q6 ===
        'volume_lift_texture'

      ) {

        return [

          'COP_AV',

          'BUR_HS',

          'AWC_HS'

        ];

      }


      return [

        'BUR_HS',

        'COP_AV',

        'AWC_HS'

      ];

    }


    if (
      answers.q8 ===
      'hold_strong'
    ) {

      if (
        answers.q4 ===
        'heat_tools'
      ) {

        return [

          'AWC_SH',

          'AWC_HS',

          'COP_AV',

          'BUR_HS'

        ];

      }


      if (
        answers.q6 ===
        'thickness_fullness'
      ) {

        return [

          'AWC_HS',

          'AWC_SH',

          'COP_AV',

          'BUR_HS'

        ];

      }


      if (
        answers.q6 ===
        'volume_lift_texture'
      ) {

        return [

          'COP_AV',

          'AWC_SH',

          'AWC_HS',

          'BUR_HS'

        ];

      }


      return [

        'AWC_HS',

        'AWC_SH',

        'BUR_HS',

        'COP_AV'

      ];

    }


    return [];

  }


  function chooseStylingSecondary(

    ranking,

    primary,

    answers

  ) {

    if (

      !primary ||

      primary.meta
        ?.standaloneCapable

    ) {

      return null;

    }


    for (

      const slot

      of preferredFinishSlots(
        answers
      )

    ) {

      if (
        slot ===
        primary.slot
      ) {

        continue;

      }


      const item =
        findEligibleSlot(

          ranking,

          slot

        );


      if (
        item
      ) {

        return item;

      }

    }


    return null;

  }


  function calculateStylingRitual(
    answers,
    products
  ) {

    const ranking =
      buildStylingRanking(

        answers,

        products

      );


    const primary =
      chooseStylingPrimary(

        ranking,

        answers

      );


    const secondary =
      chooseStylingSecondary(

        ranking,

        primary,

        answers

      );


    return {

      ranking,

      primary,

      secondary

    };

  }


  function buildStylingReason(

    item,

    answers,

    isSecondary

  ) {

    if (
      !item
    ) {

      return '';

    }


    if (
      isSecondary
    ) {

      return (
        `Added only to provide ` +
        `${HOLD_LABELS[answers.q8]}.`
      );

    }


    /*
      INSTA-SEAL COPY
    */

    if (
      item.slot ===
      'KIN_M'
    ) {

      return (
        'Chosen to help seal the cuticle, control frizz ' +
        'and support smoother heat styling.'
      );

    }


    /*
      BURITI SERUM / OIL COPY
    */

    if (
      item.slot ===
      'BUR_SS'
    ) {

      return (
        'Chosen for stronger repair, nourishment ' +
        'and smoothing during styling.'
      );

    }


    return (

      `Chosen for ` +

      `${STYLE_METHOD_LABELS[answers.q4]} ` +

      `to create ` +

      `${STYLE_GOAL_LABELS[answers.q6]}.`

    );

  }


  /* =========================================================
     PRODUCT CARD RENDERING
     ========================================================= */

  function renderProductCard(

    container,

    item,

    options = {}

  ) {

    if (
      !container
    ) {

      return;

    }


    clearElement(
      container
    );


    if (

      !item ||

      !item.product

    ) {

      container.hidden =
        true;

      return;

    }


    container.hidden =
      false;


    const product =
      item.product;


    const card =
      document.createElement(
        'article'
      );


    card.className =
      'taya-ritual__product-card';


    if (
      product.image
    ) {

      const imageLink =
        document.createElement(
          'a'
        );


      imageLink.href =
        product.url;


      imageLink.className =
        'taya-ritual__product-image-link';


      const image =
        document.createElement(
          'img'
        );


      image.src =
        product.image;


      image.alt =
        product.title ||
        '';


      image.loading =
        'lazy';


      image.className =
        'taya-ritual__product-image';


      imageLink.appendChild(
        image
      );


      card.appendChild(
        imageLink
      );

    }


    const content =
      document.createElement(
        'div'
      );


    content.className =
      'taya-ritual__product-content';


    if (
      options.role
    ) {

      const role =
        document.createElement(
          'p'
        );


      role.className =
        'taya-ritual__product-role';


      role.textContent =
        options.role;


      content.appendChild(
        role
      );

    }


    const title =
      document.createElement(
        'h4'
      );


    title.className =
      'taya-ritual__product-title';


    const titleLink =
      document.createElement(
        'a'
      );


    titleLink.href =
      product.url;


    titleLink.textContent =
      product.title;


    title.appendChild(
      titleLink
    );


    content.appendChild(
      title
    );


    if (
      product.priceFormatted
    ) {

      const price =
        document.createElement(
          'p'
        );


      price.className =
        'taya-ritual__product-price';


      price.textContent =
        product.priceFormatted;


      content.appendChild(
        price
      );

    }


    if (
      options.reason
    ) {

      const whyLabel =
        document.createElement(
          'p'
        );


      whyLabel.className =
        'taya-ritual__product-why-label';


      whyLabel.textContent =

        options.whyLabel ||

        'Why this fits your hair';


      content.appendChild(
        whyLabel
      );


      const reason =
        document.createElement(
          'p'
        );


      reason.className =
        'taya-ritual__product-reason';


      reason.textContent =
        options.reason;


      content.appendChild(
        reason
      );

    }


    const actions =
      document.createElement(
        'div'
      );


    actions.className =
      'taya-ritual__product-actions';


    const viewLink =
      document.createElement(
        'a'
      );


    viewLink.href =
      product.url;


    viewLink.className =
      'taya-ritual__button taya-ritual__button--secondary taya-ritual__product-link';


    viewLink.textContent =
      'View Product';


    actions.appendChild(
      viewLink
    );


    content.appendChild(
      actions
    );


    card.appendChild(
      content
    );


    container.appendChild(
      card
    );

  }


  function renderEssentialCare(

    root,

    result,

    answers

  ) {

    renderProductCard(

      root.querySelector(
        '[data-result-slot="essential_shampoo"]'
      ),

      result.shampoo,

      {

        role:
          'Recommended Shampoo',

        whyLabel:
          'Why this fits your hair',

        reason:
          buildEssentialReason(
            answers
          )

      }

    );


    renderProductCard(

      root.querySelector(
        '[data-result-slot="essential_conditioner"]'
      ),

      result.conditioner,

      {

        role:
          'Recommended Conditioner',

        whyLabel:
          'Why this fits your hair',

        reason:
          buildEssentialReason(
            answers
          )

      }

    );

  }


  function renderSpecialtyCare(
    root,
    result
  ) {

    const primaryContainer =
      root.querySelector(
        '[data-result-slot="specialty_primary"]'
      );


    const complementaryContainer =
      root.querySelector(
        '[data-result-slot="specialty_complementary"]'
      );


    renderProductCard(

      primaryContainer,

      result.primary,

      {

        role:
          'Our Priority for Your Hair',

        whyLabel:
          'Why this fits your hair',

        reason:
          buildSpecialtyReason(
            result.primary,
            false
          )

      }

    );


    renderProductCard(

      complementaryContainer,

      result.complementary,

      {

        role:
          'Optional Additional Care',

        whyLabel:
          'Why you may also like this',

        reason:
          buildSpecialtyReason(
            result.complementary,
            true
          )

      }

    );


    const optionalSection =
      root.querySelector(
        '[data-ritual-optional-care]'
      );


    if (
      optionalSection
    ) {

      optionalSection.hidden =
        !result.complementary;

    }

  }


  function renderStylingRitual(

    root,

    result,

    answers

  ) {

    const primaryContainer =
      root.querySelector(
        '[data-result-slot="styling_primary"]'
      );


    const secondaryContainer =
      root.querySelector(
        '[data-result-slot="styling_secondary"]'
      );


    renderProductCard(

      primaryContainer,

      result.primary,

      {

        role:
          'Style',

        whyLabel:
          'Why this fits your hair',

        reason:
          buildStylingReason(

            result.primary,

            answers,

            false

          )

      }

    );


    renderProductCard(

      secondaryContainer,

      result.secondary,

      {

        role:
          'Finish',

        whyLabel:
          'Why this fits your hair',

        reason:
          buildStylingReason(

            result.secondary,

            answers,

            true

          )

      }

    );


    const primaryColumn =
      primaryContainer?.closest(
        '.taya-ritual__ritual-column'
      );


    const primaryStepLabel =
      primaryColumn?.querySelector(
        '.taya-ritual__ritual-step-label strong'
      );


    if (
      primaryStepLabel
    ) {

      const canStandAlone =
        Boolean(

          result.primary
            ?.meta
            ?.standaloneCapable

        );


      const primaryIsFinisher =

        result.primary
          ?.meta
          ?.stage ===
        'finish';


      primaryStepLabel.textContent =

        !result.secondary &&

        (
          canStandAlone ||
          primaryIsFinisher
        )

          ? 'Style & Finish'

          : 'Style';

    }

  }


  /* =========================================================
     QUIZ APP
     ========================================================= */

  function initTayaRitual(
    root
  ) {

    if (

      !root ||

      root.dataset
        .ritualInitialized ===
        'true'

    ) {

      return;

    }


    root.dataset
      .ritualInitialized =
      'true';


    const screens = [
      ...root.querySelectorAll(
        '[data-ritual-screen]'
      )
    ];


    const form =
      root.querySelector(
        '[data-ritual-form]'
      );


    const questions = [
      ...root.querySelectorAll(
        '[data-ritual-question]'
      )
    ];


    const progressLabel =
      root.querySelector(
        '[data-ritual-progress-label]'
      );


    const progress =
      root.querySelector(
        '.taya-ritual__progress'
      );


    const progressBar =
      root.querySelector(
        '[data-ritual-progress-bar]'
      );


    const errorMessage =
      root.querySelector(
        '[data-ritual-error]'
      );


    const backButton =
      root.querySelector(
        '[data-ritual-action="back"]'
      );


    const nextButton =
      root.querySelector(
        '[data-ritual-action="next"]'
      );


    const completeButton =
      root.querySelector(
        '[data-ritual-action="complete"]'
      );


    if (

      !form ||

      questions.length !==
        QUESTION_KEYS.length

    ) {

      return;

    }


    const productRegistry =
      parseProductRegistry(
        root
      );


    const state = {

      currentIndex: 0,

      answers:
        loadStoredAnswers(),

      products:
        productRegistry.products ||
        []

    };


    function showScreen(
      name
    ) {

      screens.forEach(
        (screen) => {

          screen.hidden =

            screen.dataset
              .ritualScreen !==
            name;

        }
      );

    }


    function firstUnansweredIndex() {

      const index =
        QUESTION_KEYS.findIndex(
          (key) =>

            !state.answers[
              key
            ]
        );


      return index === -1
        ? 0
        : index;

    }


    function restoreSelections() {

      Object.entries(
        state.answers
      ).forEach(
        ([name, value]) => {

          const input =
            form.querySelector(

              `input[name="${CSS.escape(
                name
              )}"][value="${CSS.escape(
                value
              )}"]`

            );


          if (
            input
          ) {

            input.checked =
              true;

          }

        }
      );

    }


    function selectedValueForCurrentQuestion() {

      const key =
        QUESTION_KEYS[
          state.currentIndex
        ];


      return (

        form.querySelector(
          `input[name="${key}"]:checked`
        )?.value ||

        null

      );

    }


    function updateProgress() {

      const humanIndex =
        state.currentIndex +
        1;


      const percent =
        (
          humanIndex /
          QUESTION_KEYS.length
        ) *
        100;


      if (
        progressLabel
      ) {

        progressLabel.textContent =
          `Question ${humanIndex} of ${QUESTION_KEYS.length}`;

      }


      if (
        progress
      ) {

        progress.setAttribute(

          'aria-valuenow',

          String(
            humanIndex
          )

        );

      }


      if (
        progressBar
      ) {

        progressBar.style.width =
          `${percent}%`;

      }

    }


    function renderQuestion() {

      questions.forEach(
        (
          question,
          index
        ) => {

          question.hidden =

            index !==
            state.currentIndex;

        }
      );


      const isFirst =
        state.currentIndex ===
        0;


      const isLast =
        state.currentIndex ===
        QUESTION_KEYS.length -
        1;


      if (
        backButton
      ) {

        backButton.hidden =
          isFirst;

      }


      if (
        nextButton
      ) {

        nextButton.hidden =
          isLast;

      }


      if (
        completeButton
      ) {

        completeButton.hidden =
          !isLast;

      }


      if (
        errorMessage
      ) {

        errorMessage.hidden =
          true;

      }


      updateProgress();

    }


    function commitCurrentAnswer() {

      const key =
        QUESTION_KEYS[
          state.currentIndex
        ];


      const value =
        selectedValueForCurrentQuestion();


      if (
        !value
      ) {

        if (
          errorMessage
        ) {

          errorMessage.hidden =
            false;

        }


        return false;

      }


      state.answers[
        key
      ] =
        value;


      saveAnswers(
        state.answers
      );


      if (
        errorMessage
      ) {

        errorMessage.hidden =
          true;

      }


      return true;

    }


    function startQuiz() {

      restoreSelections();


      state.currentIndex =
        firstUnansweredIndex();


      showScreen(
        'quiz'
      );


      renderQuestion();

    }


    function nextQuestion() {

      if (
        !commitCurrentAnswer()
      ) {

        return;

      }


      if (

        state.currentIndex <
        QUESTION_KEYS.length -
        1

      ) {

        state.currentIndex +=
          1;


        renderQuestion();

      }

    }


    function previousQuestion() {

      if (
        state.currentIndex >
        0
      ) {

        state.currentIndex -=
          1;


        renderQuestion();

      }

    }


    function completeQuiz(
      event
    ) {

      event.preventDefault();


      if (
        !commitCurrentAnswer()
      ) {

        return;

      }


      const essentialCare =
        calculateEssentialCare(

          state.answers,

          state.products

        );


      const specialtyCare =
        calculateSpecialtyCare(

          state.answers,

          state.products

        );


      const stylingRitual =
        calculateStylingRitual(

          state.answers,

          state.products

        );


      renderEssentialCare(

        root,

        essentialCare,

        state.answers

      );


      renderSpecialtyCare(

        root,

        specialtyCare

      );


      renderStylingRitual(

        root,

        stylingRitual,

        state.answers

      );


      showScreen(
        'results'
      );

    }


    function restartQuiz() {

      sessionStorage.removeItem(
        STORAGE_KEY
      );


      state.answers = {};


      state.currentIndex =
        0;


      form.reset();


      showScreen(
        'intro'
      );

    }


    root.addEventListener(
      'click',
      (event) => {

        const trigger =
          event.target.closest(
            '[data-ritual-action]'
          );


        if (
          !trigger
        ) {

          return;

        }


        switch (
          trigger.dataset
            .ritualAction
        ) {

          case 'start':

            startQuiz();

            break;


          case 'next':

            nextQuestion();

            break;


          case 'back':

            previousQuestion();

            break;


          case 'restart':

            restartQuiz();

            break;

        }

      }
    );


    form.addEventListener(
      'change',
      (event) => {

        if (

          !(
            event.target instanceof
            HTMLInputElement
          ) ||

          event.target.type !==
          'radio'

        ) {

          return;

        }


        state.answers[
          event.target.name
        ] =
          event.target.value;


        saveAnswers(
          state.answers
        );


        if (
          errorMessage
        ) {

          errorMessage.hidden =
            true;

        }

      }
    );


    form.addEventListener(
      'submit',
      completeQuiz
    );


    restoreSelections();


    showScreen(
      'intro'
    );

  }


  function initAll(
    scope = document
  ) {

    if (

      scope.matches?.(
        '[data-taya-ritual-root]'
      )

    ) {

      initTayaRitual(
        scope
      );

    }


    scope
      .querySelectorAll?.(
        '[data-taya-ritual-root]'
      )
      .forEach(
        initTayaRitual
      );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(

      'DOMContentLoaded',

      () =>
        initAll(
          document
        )

    );

  } else {

    initAll(
      document
    );

  }


  document.addEventListener(

    'shopify:section:load',

    (event) => {

      initAll(
        event.target
      );

    }

  );

})();